import React, { createContext, useCallback, useContext } from 'react';
import useSnack from '../hooks/useSnack';
import AuthProvider from './AuthProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ProjectProvider from './ProjectProvider';
import OrganizationProvider from './OrganizationProvider';
import ThemeContextProvider from './ThemeProvider';

const ProviderContext = createContext();

const Provider = ({ children }) => {
    const { SnackBar, showMessage } = useSnack();

    return (
        <ProviderContext.Provider value={{ showMessage }}>
            <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <ThemeContextProvider>
                    <AuthProvider>
                        <OrganizationProvider>
                            <ProjectProvider>
                                {children}
                                {SnackBar}
                            </ProjectProvider>
                        </OrganizationProvider>
                    </AuthProvider>
                </ThemeContextProvider>
            </GoogleOAuthProvider>
        </ProviderContext.Provider>
    );
};

const useMessage = () => {
    const showMessage = useContext(ProviderContext)?.showMessage;

    const showSuccess = useCallback(
        function (msg) {
            showMessage({ success: msg });
        },
        [showMessage]
    );

    const showError = useCallback(
        function (msg) {
            Array.isArray(msg)
                ? msg.forEach(msg => showMessage({ error: msg }))
                : showMessage({ error: msg });
        },
        [showMessage]
    );

    const showResponse = useCallback(
        function (msg, action) {
            showMessage({ response: msg, action });
        },
        [showMessage]
    );

    return { showError, showSuccess, showResponse };
};

// const useEventEmitter = () => {
//     const eventEmitter = useContext(HeaderContext).eventEmitter;
//     return eventEmitter;
// };

export { useMessage, ProviderContext as HeaderContext };

export default Provider;

